module.exports = __webpack_public_path__ + "static/media/alertRed.19e65d9b.svg";